import { Component, ReactNode } from "react";
import { WhatsAppCta } from "./WhatsAppCta";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// Sem isso, qualquer erro de render (nosso ou de terceiros - extensao de navegador, tradutor
// automatico, etc) derruba a arvore inteira do React e deixa uma tela branca, sem chance de
// recuperar sem apertar F5. Aqui pelo menos sobra uma tela com um botao de "Recarregar" e um
// jeito de falar com a gente, em vez de branco puro.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("Erro capturado pelo ErrorBoundary:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-paper px-5 text-center">
          <h1 className="text-2xl font-bold">Algo deu errado</h1>
          <p className="max-w-[40ch] text-ink/60">
            Essa pagina encontrou um erro inesperado. Tenta recarregar - se continuar
            acontecendo, avisa a gente.
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => window.location.reload()}
              className="rounded-lg border-2 border-ink bg-brand-600 px-5 py-2.5 text-sm font-bold text-white shadow-solid-sm"
            >
              Recarregar pagina
            </button>
            <WhatsAppCta variant="outline" message="Ola! Encontrei um erro no site da SendCube.">
              Avisar a SendCube
            </WhatsAppCta>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
